/**
 * Finishing - Twitter
 *
 * JS pour la gestion de Twitter
 *
 * @since       08.10.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/********************************************************/
/********** CHARGEMENT DE LA LIBRAIRIE TWITTER **********/
/********************************************************/

window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) { return t; }
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
 
  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };
 
  return t;
}(document, "script", "twitter-wjs"));

/*
window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
 
  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };
 
  return t;
}(document, "script", "twitter-wjs"));
*/

/*********************************************************************************/
/*********************************************************************************/